import { render, staticRenderFns } from "./KvButton.vue?vue&type=template&id=1d3461da&"
import script from "./KvButton.vue?vue&type=script&lang=ts&"
export * from "./KvButton.vue?vue&type=script&lang=ts&"
import style0 from "./KvButton.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports